import React from 'react'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import { IEstimateToBeReviewedStageProps } from '../stages/interfaces/IEstimateToBeReviewedStageProps'
import { checkConsultant } from 'application/helpers'
import globals from 'application/constants/globals'
import { HomeStaticData } from './../homeStaticData'

const EstimateToBeReviewedStage = (props: IEstimateToBeReviewedStageProps) => {
  const {
    firstName,
    estimateLink,
    isRelease,
    isSparta,
    consultantFirstName,
    finAppUrl,
  } = props

  let bannerContent = HomeStaticData('EstimateReviewBannerText', {
    consultantFirstName: consultantFirstName,
  })

  if (isRelease)
    bannerContent = HomeStaticData('EstimateReviewReleaseBannerText', {
      consultantFirstName: consultantFirstName,
      brand: globals.brand,
    })
  if (isSparta)
    bannerContent = HomeStaticData('EstimateReviewSpartaBannerText', {
      consultantFirstName: consultantFirstName,
    })

  if (finAppUrl !== '')
    bannerContent += `
      
      Please click on 'Start finance application' to complete your Finance application for ${consultantFirstName} to get quick financier approval for you.`

  const firstButton = {
    buttonName: 'View my estimates',
    disabled: false,
    linkUrl: estimateLink,
  }
  const secondButton = {
    buttonName: finAppUrl && 'Start finance application',
    disabled: checkConsultant(),
    linkUrl: finAppUrl,
  }
  const sectionTitle = `Hi ${firstName},`
  const sectionContent = bannerContent
  const bannerImageText = globals.isBrandMX
    ? 'Ready to drive your salary further?'
    : `Ready to get in the driver’s seat?`

  return (
    <BannerBrandImageSection
      id="estimatetobereviewedstage.bannermainsection"
      imageText={bannerImageText}
      sectionContent={sectionContent}
      sectionTitle={sectionTitle}
      firstButton={firstButton}
      secondButton={secondButton}
    />
  )
}

export default EstimateToBeReviewedStage
